export class MapExternalLayer {
  public url: string;
  public layer: string;
  public filter: string;
  public value: string;
  public style: string;
  public ids: string[] = [];
}
